import type { PluginContainerData } from 'ricos-schema';
import type { EditorPluginConfig, ViewerPluginConfig } from 'wix-rich-content-common';

export const COLLAPSIBLE_LIST_TYPE = 'wix-rich-content-plugin-collapsible-list';

export interface CollapsibleListPluginEditorConfig extends EditorPluginConfig {
  isQapageData?: boolean;
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface CollapsibleListPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

// took from proto definition -
// https://github.com/wix-private/ricos/blob/master/packages/ricos-schema/src/main/proto/wix/rich_content/v1/plugin_collapsible_list.proto
export type CollapsibleListComponentData = {
  containerData: PluginContainerData;
  expandOnlyOne: boolean;
  initialExpandedItems: InitialExpandedItems;
  direction?: ListDirection;
  isQapageData?: boolean;
};

export const initialExpandedItems = {
  FIRST: 'FIRST',
  ALL: 'ALL',
  NONE: 'NONE',
} as const;

export type InitialExpandedItems = (typeof initialExpandedItems)[keyof typeof initialExpandedItems];

export const listDirection = {
  LTR: 'LTR',
  RTL: 'RTL',
} as const;

export type ListDirection = (typeof listDirection)[keyof typeof listDirection];
